import { CenteredDiv, ErrorText, useQueryParams } from '@main/core-ui';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

import { notFoundMessages } from './messages';
import { NotFoundWrapper } from './wrappers';

/**
 * The Not Found Page, displayed when a page is not found
 * This is the page we show when the user visits a url that doesn't have a route
 */
export const NotFound: React.FC<{
  /** message to display */
  message?: string;
}> = ({ message }) => {
  const { formatMessage } = useIntl();
  const { msg } = useQueryParams();
  return (
    <NotFoundWrapper spacing={35}>
      <CenteredDiv>
        <Helmet>
          <title>{formatMessage(notFoundMessages.title)}</title>
          <meta
            content={formatMessage(notFoundMessages.title)}
            name="description"
          />
        </Helmet>
        <h1>{formatMessage(notFoundMessages.header)}</h1>
        {message && <ErrorText>{message}</ErrorText>}
      </CenteredDiv>
      {msg && <ErrorText>{msg}</ErrorText>}
    </NotFoundWrapper>
  );
};
export default NotFound;
